module.exports = __webpack_public_path__ + "static/media/ic_arrow_right.e833d44f.svg";